import gsap from 'gsap';

export function setUpBlade5aAnimation () {
    gsap.set('.blade-5a-second-headline', {alpha: 0});
    gsap.set('.blade-5-icons', {alpha: 0});
}

export function blade5aanimation () {

    const obj1 = {
        alpha: 0,
        delay: 1.5, 
        duration: 1.0,
        y: '50%',
    }

    gsap.set('.blade-5a-second-headline', {alpha: 1})

    gsap.from('.blade-5a-second-headline', obj1)

}

export function blade5Iconanimation () {

    const obj1 = {
        alpha: 0,
        delay: 0, 
        duration: 1.0,
    }

    gsap.set('.blade-5-icons', {alpha: 1})

    gsap.from('.blade-5-icons', obj1)

    gsap.to('.blade-5-icons', {onComplete: divider})

    function divider () {
        const dividerContainer = document.querySelectorAll('.divider-wrap');
        const textRevealer = document.querySelectorAll('.text-conceal');
        
        for(let i = 0; i < dividerContainer.length; i++) {
            let iconBar = dividerContainer[i];
            const tl = gsap.timeline({repeat: 0});
            tl.to(iconBar, 1, {width:"100%", visibility: "visible"});
        }
    
        for(let i = 0; i < textRevealer.length; i++) {
            let text = textRevealer[i];
            const tl = gsap.timeline({repeat: 0});
            tl.to(text, 1, {width:"0%"});
        }
    
    }

}